import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_12 = { class: "flex px-2 py-6 space-x-2 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_14 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_15 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_16 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_17 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_18 = { class: "px-2 py-2 whitespace-nowrap" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "py-8 text-center" }

import { PropType, ref } from "vue";

import api from "@/api/api";
import { Club, User } from "@/types";

import TimezoneSpan from "../TimezoneSpan.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserClubs',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;



const clubs = ref([] as Club[]);
clubs.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.users.getClubsByUser(props.user.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.clubs;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (clubs.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t(`name`)), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t(`date`)), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t(`facilitator`)), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t(`location`)), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t(`setting`)), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t(`status`)), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: club.id
              }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(club.name), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(TimezoneSpan, {
                    date: club.first_club_date,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "long",
                    showTime: false
                  }, null, 8, ["date"]),
                  _hoisted_13,
                  _createVNode(TimezoneSpan, {
                    date: club.last_club_date,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "long",
                    showTime: false
                  }, null, 8, ["date"])
                ]),
                _createElementVNode("td", _hoisted_14, _toDisplayString(club.facilitator.first_name) + " " + _toDisplayString(club.facilitator.last_name), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(`${club.address_line_one} ${club.address_line_two !== null ? `, ${club.address_line_two}` : ""}, ${club.city}, ${club.postcode}, ${club.country}`), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(club.setting), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(club.status), 1),
                _createElementVNode("td", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/clubs/${club.id}`,
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view-club-details")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("this-user-has-no-brick-clubs")), 1)
      ]))
}
}

})